import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import api from './utils/api'
import './assets/css/style.less'
import 'lib-flexible'
import Vant from 'vant';
Vue.use(Vant);
Vue.config.productionTip = false
import VueClipboard from 'vue-clipboard2'
import 'vant/lib/index.css';
Vue.use(VueClipboard)
Vue.prototype.$api = api
import './utils/tools'
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

// 微信开放标签由微信客户端注册，Vue 不应将其当作组件解析。
Vue.config.ignoredElements = ['wx-open-launch-weapp']

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
